import styled, { css } from 'theme/styled';

export const maxWidth = 960;

interface ContainerProps {
  justifyContent?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';
  alignContent?:
    | 'stretch'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around';
  direction?: 'column' | 'row';
  margins?: number;
}

export const Container = styled('div')<ContainerProps>`
  display: flex;
  width: 100%;
  max-width: ${maxWidth}px;
  height: 100%;
  margin: ${({ margins }) => (typeof margins === 'undefined' ? 3 : margins)}em
    auto;
  position: relative;
  flex-direction: ${({ direction }) => direction || 'column'};

  ${({ alignItems }) =>
    alignItems
      ? css`
          align-items: ${alignItems};
        `
      : ''}
  ${({ alignContent }) =>
    alignContent
      ? css`
          align-content: ${alignContent};
        `
      : ''}
  ${({ justifyContent }) =>
    justifyContent
      ? css`
          justify-content: ${justifyContent};
        `
      : ''}

  @media (max-width: ${maxWidth}px) {
    padding: 0 ${({ theme }) => theme.spacing(2)};
  }
`;

export default undefined;
